import { DefaultOptionType } from "antd/es/select"

import { NetworkCrypto } from "@src/shared/api/generated"
import {
  FIELDS_TYPE,
  FiltersFieldSelectType,
  FiltersFieldType,
} from "@src/shared/componemts/TableFilter/types"

export const getFilterSimpleFiled = (name: string) => {
  const label = name.charAt(0).toUpperCase() + name.slice(1)

  return {
    date(add: Partial<FiltersFieldType> = {}): FiltersFieldType {
      return {
        name,
        prepareValue: (v) => prepares(v).date(["dateTo", "dateFrom"]),
        type: FIELDS_TYPE.DATE,
        ...add,
      }
    },

    search(add: Partial<FiltersFieldType> = {}): FiltersFieldType {
      return {
        label,
        name,
        type: FIELDS_TYPE.SEARCH,
        ...add,
      }
    },

    select(
      options: DefaultOptionType[],
      add: Partial<FiltersFieldType> = {},
    ): FiltersFieldSelectType {
      return {
        label,
        name,
        options,
        type: FIELDS_TYPE.SELECT,
        ...add,
      }
    },
  }
}

export const prepares = (value: unknown) => {
  return {
    currencies: () => {
      const [symbol, network] = (value as string).split(",") as [
        string,
        NetworkCrypto,
      ]

      return {
        network,
        symbol,
      }
    },

    date: ([keyTo = "to", keyFrom = "from"] = []) => {
      const [from, to] = value as string[]

      return {
        [keyFrom]: new Date(from as string).toISOString(),
        [keyTo]: new Date(to as string).toISOString(),
      }
    },
  }
}

export const filtersPresets = {
  order: getFilterSimpleFiled("order").select(
    [
      { label: "Newest", value: "desc" },
      { label: "Oldest", value: "asc" },
    ],
    { placeholder: "Select an order" },
  ),

  status: getFilterSimpleFiled("status").select(
    [
      { label: "Failed", value: "failed" },
      { label: "Pending", value: "pending" },
      { label: "Confirmed", value: "confirmed" },
    ],
    { placeholder: "Select a status" },
  ),
}
